import React, { useEffect, useState } from "react";
import axios from "axios";
import Layout from "../../layouts/index.jsx";
import Header from "../../layouts/header/index.jsx";
import Footer from "../../layouts/footer/index.jsx";
import ScrollToTop from "../../components/scroll-to-top/index.jsx";
import SEO from "../../components/seo/index.jsx";
import { showToast } from "../../utils/toast.js";
import { } from "react-toastify"; import DocumentosTable from "./DocumentosTable.jsx";
import ModalEliminarArchivo from "./ModalEliminarArchivo.jsx";
import ModalDocumentosGenerales from "./ModalDocumentosGenerales";

const API = process.env.REACT_APP_API_URL;
const token = sessionStorage.getItem("token");

const DocumentosContainer = () => {
    const [form, setForm] = useState({
        nombrearchivo: "",
        mimearchivo: "",
        fechasubida: "",
        idusuario: sessionStorage.getItem("idUsuario") || "",
        idtipodocumento: "",
        idempleado: "",
        archivoFile: null
    });
    const [mensaje, setMensaje] = useState("");
    const [documentos, setDocumentos] = useState([]);
    const [tiposDocumento, setTiposDocumento] = useState([]);
    const [empleados, setEmpleados] = useState([]);
    const [editingId, setEditingId] = useState(null);
    const [mostrarFormulario, setMostrarFormulario] = useState(false);
    const [mostrarModalEliminar, setMostrarModalEliminar] = useState(false);
    const [documentoAEliminar, setDocumentoAEliminar] = useState(null);
    const [paginaActual, setPaginaActual] = useState(1);
    const [elementosPorPagina, setElementosPorPagina] = useState(5);
    const [busqueda, setBusqueda] = useState("");
    const [mostrarSinArchivo, setMostrarSinArchivo] = useState(false);
    const idRol = Number(sessionStorage.getItem("idRol"));
    const usuarioSesion = JSON.parse(
        sessionStorage.getItem("usuario") || "{}"
    );
    const idEmpleadoSesion = Number(
        usuarioSesion.idempleado || 0
    );
    const esAdministrador = [4, 5].includes(idRol);
    const [verSoloMisDocumentos, setVerSoloMisDocumentos] = useState(false);
    const [mostrarModalGeneral, setMostrarModalGeneral] = useState(false);

    const [formDocumentoGeneral, setFormDocumentoGeneral] = useState({
        nombrearchivo: "",
        mimearchivo: "",
        archivoFile: null
    });

    useEffect(() => {
        fetchDocumentos();
        fetchTiposDocumento();
        fetchEmpleados();
    }, []);

    const handleSubmitDocumentoGeneral = async (e) => {
        e.preventDefault();

        if (
            !formDocumentoGeneral.nombrearchivo ||
            !formDocumentoGeneral.archivoFile
        ) {
            showToast("Todos los campos son obligatorios", "error");
            return;
        }

        const tipoDocumentoGeneral = tiposDocumento.find(
            t =>
                (t.nombretipo || "")
                    .toUpperCase()
                    .trim() === "DOCUMENTO GENERAL"
        );

        if (!tipoDocumentoGeneral) {
            showToast(
                "No existe el tipo de documento DOCUMENTO GENERAL",
                "error"
            );
            return;
        }

        try {
            const formData = new FormData();

            formData.append(
                "nombrearchivo",
                formDocumentoGeneral.nombrearchivo
            );

            formData.append(
                "mimearchivo",
                formDocumentoGeneral.mimearchivo
            );

            formData.append(
                "archivo",
                formDocumentoGeneral.archivoFile
            );

            formData.append(
                "fechasubida",
                new Date().toISOString().slice(0, 10)
            );

            formData.append("estado", true);

            formData.append(
                "idusuario",
                sessionStorage.getItem("idUsuario")
            );

            formData.append(
                "idtipodocumento",
                tipoDocumentoGeneral.idtipodocumento
            );

            await axios.post(
                `${API}/documentos/`,
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                        Authorization: `Bearer ${token}`
                    }
                }
            );

            showToast(
                "Documento general registrado correctamente"
            );

            setFormDocumentoGeneral({
                nombrearchivo: "",
                mimearchivo: "",
                archivoFile: null
            });

            setMostrarModalGeneral(false);

            fetchDocumentos();

        } catch (error) {
            console.error(
                error.response?.data || error
            );

            showToast(
                "Error al registrar documento general",
                "error"
            );
        }
    };

    const onChangeDocumentoGeneral = (e) => {
        const { name, value, files } = e.target;

        if (files && files.length > 0) {
            const file = files[0];

            setFormDocumentoGeneral((prev) => ({
                ...prev,
                archivoFile: file,
                mimearchivo: file.name.split(".").pop().toLowerCase()
            }));
        } else {
            setFormDocumentoGeneral((prev) => ({
                ...prev,
                [name]: value
            }));
        }
    };

    const fetchDocumentos = async () => {
        try {
            const r = await axios.get(`${API}/documentos/`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            const data = Array.isArray(r.data) ? r.data : Array.isArray(r.data?.results) ? r.data.results : [];
            setDocumentos(data);
        } catch (error) {
            showToast("Error al cargar los documentos", "error");
            setDocumentos([]);
        }
    };

    const fetchTiposDocumento = async () => {
        try {
            const r = await axios.get(`${API}/tipodocumento/`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            const data = Array.isArray(r.data) ? r.data : Array.isArray(r.data?.results) ? r.data.results : [];
            setTiposDocumento(data);
        } catch (error) {
            console.error("Error al cargar tipos de documento:", error);
            showToast("Error al cargar tipos de documento:", "error");
            setTiposDocumento([]);
        }
    };

    const fetchEmpleados = async () => {
        try {
            const r = await axios.get(`${API}/empleados/`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            const data = Array.isArray(r.data) ? r.data : Array.isArray(r.data?.results) ? r.data.results : [];
            setEmpleados(data);
        } catch (error) {
            console.error("Error al cargar Trabajadores/as:", error);
            showToast("Error al cargar Trabajadores/as:", "error");
            setEmpleados([]);
        }
    };

    const onChange = e => {
        const { name, files, value } = e.target;
        if (files && files.length > 0) {
            const file = files[0];
            const extension = file.name.split(".").pop().toLowerCase();
            // Quitar la extensión del nombre del archivo
            const nombreSinExtension = file.name.replace(/\.[^/.]+$/, "");
            setForm(f => ({
                ...f,
                archivoFile: file,
                mimearchivo: extension,
                nombrearchivo: nombreSinExtension
            }));
        } else {
            setForm(f => ({
                ...f,
                [name]: value
            }));
        }
    };

    const handleSubmit = async e => {
        e.preventDefault();

        if (
            !form.nombrearchivo ||
            !form.idtipodocumento ||
            !form.idempleado ||
            (!form.archivoFile && !editingId)
        ) {
            setMensaje("Todos los campos son obligatorios");
            showToast("Todos los campos son obligatorios");
            return;
        }

        const idUsuario = sessionStorage.getItem("idUsuario");
        const formData = new FormData();

        // Siempre usar la fecha actual
        const fechaActual = new Date().toISOString().slice(0, 10);

        let nombreFinal = form.nombrearchivo;
        let extension = form.mimearchivo;

        if (form.archivoFile) {
            extension = form.archivoFile.name.split(".").pop().toLowerCase();
            // Solo agregar extensión para el archivo físico, no para el nombre mostrado
            formData.append("archivo", form.archivoFile);
        }

        formData.append("nombrearchivo", nombreFinal);
        formData.append("mimearchivo", extension);
        formData.append("fechasubida", fechaActual);
        formData.append("estado", true);
        formData.append("idusuario", idUsuario);
        formData.append("idtipodocumento", form.idtipodocumento);
        formData.append("idempleado", form.idempleado);

        try {
            if (editingId) {
                await axios.put(`${API}/documentos/${editingId}/`, formData, {
                    headers: { "Content-Type": "multipart/form-data", Authorization: `Bearer ${token}` }
                });
                showToast("Documento actualizado correctamente");
            } else {
                await axios.post(`${API}/documentos/`, formData, {
                    headers: { "Content-Type": "multipart/form-data", Authorization: `Bearer ${token}` }
                });
                showToast("Documento registrado correctamente");
            }

            setForm({
                nombrearchivo: "",
                mimearchivo: "",
                fechasubida: "",
                idtipodocumento: "",
                idempleado: "",
                archivoFile: null
            });
            setEditingId(null);
            setMostrarFormulario(false);
            fetchDocumentos();
        } catch (error) {
            console.error("Error al guardar documento:", e.response?.data || error);
            setMensaje("Error al registrar o actualizar el documento");
            showToast("Error al registrar o actualizar el documento", "error");
        }
    };

    const handleEdit = row => {
        setForm({
            nombrearchivo: row.nombrearchivo ?? "",
            mimearchivo: row.mimearchivo ?? "",
            fechasubida: "",
            idusuario: row.idusuario ?? (sessionStorage.getItem("idUsuario") || ""),
            idtipodocumento: row.idtipodocumento ?? "",
            idempleado: row.idempleado ?? "",
            archivoFile: null
        });
        setEditingId(row.iddocumento);
        setMostrarFormulario(true);
    };

    const handleDeleteArchivo = async id => {
        try {
            const formData = new FormData();
            formData.append("borrar_archivo", "true");
            formData.append("nombrearchivo", form.nombrearchivo + " (archivo eliminado)");
            formData.append("fechasubida", form.fechasubida);
            formData.append("idusuario", form.idusuario);
            formData.append("idtipodocumento", form.idtipodocumento);
            formData.append("idempleado", form.idempleado);
            formData.append("mimearchivo", "-----");

            await axios.put(`${API}/documentos/${id}/`, formData, {
                headers: { "Content-Type": "multipart/form-data", Authorization: `Bearer ${token}` }
            });

            showToast("Archivo eliminado correctamente");
            setForm(f => ({
                ...f,
                archivoFile: null,
                mimearchivo: "-----",
                nombrearchivo: f.nombrearchivo + " (archivo eliminado)"
            }));

            setEditingId(null);
            setMostrarFormulario(false);
            setDocumentoAEliminar(null);

            fetchDocumentos();
        } catch (error) {
            console.error("Error al eliminar archivo:", error.response?.data || error);
            showToast("No se pudo eliminar el archivo", "error");
        }
    };

    // Nueva función para eliminar documento completamente (marcar como inactivo)
    const handleDelete = async id => {
        try {
            // Obtener primero el documento para mantener sus datos
            const response = await axios.get(`${API}/documentos/${id}/`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            const documento = response.data;

            const formData = new FormData();
            formData.append("nombrearchivo", documento.nombrearchivo || "");
            formData.append("mimearchivo", documento.mimearchivo || "");
            formData.append("fechasubida", documento.fechasubida || "");
            formData.append("estado", false); // Marcar como inactivo
            formData.append("idusuario", documento.idusuario || "");
            formData.append("idtipodocumento", documento.idtipodocumento || "");
            formData.append("idempleado", documento.idempleado || "");

            await axios.put(`${API}/documentos/${id}/`, formData, {
                headers: { "Content-Type": "multipart/form-data", Authorization: `Bearer ${token}` }
            });

            showToast("Documento eliminado correctamente");
            fetchDocumentos();
        } catch (error) {
            console.error("Error al eliminar documento:", error.response?.data || error);
            showToast("No se pudo eliminar el documento", "error");
        }
    };

    const downloadFile = async (
        archivo_url,
        nombre,
        extension
    ) => {
        try {
            const response = await axios.get(
                archivo_url,
                { responseType: "blob" }
            );

            const urlBlob =
                window.URL.createObjectURL(response.data);

            const link =
                document.createElement("a");

            link.href = urlBlob;

            link.setAttribute(
                "download",
                `${nombre}.${extension}`
            );

            document.body.appendChild(link);
            link.click();
            link.remove();

        } catch (error) {
            console.error(error);
        }
    };
    const idUsuarioSesion = Number(sessionStorage.getItem("idUsuario"));

    const documentosFiltrados = documentos
        .filter((d) => {

            if ([1, 2, 3].includes(idRol)) {

                const tipoDoc = tiposDocumento.find(
                    t => Number(t.idtipodocumento) === Number(d.idtipodocumento)
                );

                const esDocumentoGeneral =
                    (tipoDoc?.nombretipo || "")
                        .toUpperCase()
                        .trim() === "DOCUMENTO GENERAL";

                const esMiDocumento =
                    Number(d.idempleado) === idEmpleadoSesion;

                const loSubiYo =
                    Number(d.idusuario) === idUsuarioSesion;

                return esDocumentoGeneral || esMiDocumento || loSubiYo;
            }

            if (esAdministrador && verSoloMisDocumentos) {

                const tipoDoc = tiposDocumento.find(
                    t => Number(t.idtipodocumento) === Number(d.idtipodocumento)
                );

                const esDocumentoGeneral =
                    (tipoDoc?.nombretipo || "")
                        .toUpperCase()
                        .trim() === "DOCUMENTO GENERAL";

                const esMiDocumento =
                    Number(d.idempleado) === idEmpleadoSesion;

                const loSubiYo =
                    Number(d.idusuario) === idUsuarioSesion;

                return esDocumentoGeneral || esMiDocumento || loSubiYo;
            }

            return true;
        })
        .sort((a, b) => (b.iddocumento || 0) - (a.iddocumento || 0))
        .filter(d => {

            const termino = busqueda.toLowerCase().trim();

            const empleado = empleados.find(
                emp => Number(emp.idempleado) === Number(d.idempleado)
            );

            const nombreEmp =
                `${empleado?.nombre || ""} ${empleado?.apellido || ""}`
                    .toLowerCase();

            const nombreDoc =
                (d.nombrearchivo || "").toLowerCase();

            const tipoDocumento =
                (
                    tiposDocumento.find(
                        t => Number(t.idtipodocumento) === Number(d.idtipodocumento)
                    )?.nombretipo || ""
                ).toLowerCase();

            const coincide =
                nombreDoc.includes(termino) ||
                nombreEmp.includes(termino) ||
                tipoDocumento.includes(termino);

            const esSinArchivo =
                d.estado === false ||
                !d.archivo_url ||
                d.mimearchivo === "-----" ||
                nombreDoc.includes("(archivo eliminado)");

            if (mostrarSinArchivo) {
                // Checkbox activado: mostrar únicamente documentos sin archivo
                return coincide && esSinArchivo;
            }

            // Checkbox desactivado: ocultar documentos sin archivo
            return coincide && !esSinArchivo;
        });



    const indexOfLast = paginaActual * elementosPorPagina;
    const indexOfFirst = indexOfLast - elementosPorPagina;
    const documentosPaginados = documentosFiltrados.slice(indexOfFirst, indexOfLast);
    const totalPaginas = Math.max(1, Math.ceil(documentosFiltrados.length / elementosPorPagina));

    return (
        <Layout>
            <SEO title="Documentos" />
            <div className="wrapper" style={{ display: "flex", minHeight: "100vh" }}>
                <div style={{ flex: 1, display: "flex", flexDirection: "column" }}>
                    <Header />
                    <main
                        className="main-content site-wrapper-reveal"
                        style={{
                            flex: 1,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            backgroundColor: "#EEF2F7",
                            padding: "48px 20px 8rem"
                        }}
                    >
                        <div style={{ width: "min(1100px, 96vw)" }}>
                            <h2 style={{ marginBottom: "20px", textAlign: "center" }}>Documentos Registrados</h2>

                            {mensaje && (
                                <p
                                    style={{
                                        textAlign: "center",
                                        color: mensaje.includes("Error") ? "red" : "green",
                                        fontWeight: "bold"
                                    }}
                                >
                                    {mensaje}
                                </p>
                            )}

                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    gap: "10px",
                                    marginBottom: "15px"
                                }}
                            >
                                <input
                                    type="text"
                                    placeholder="Buscar documento..."
                                    value={busqueda}
                                    onChange={e => {
                                        setBusqueda(e.target.value);
                                        setPaginaActual(1);
                                    }}
                                    style={{
                                        flex: 1,
                                        padding: "10px",
                                        borderRadius: "6px",
                                        border: "1px solid #ccc"
                                    }}
                                />

                                {esAdministrador && (
                                    <button
                                        onClick={() => setMostrarModalGeneral(true)}
                                        style={{
                                            backgroundColor: "#219ebc",
                                            color: "#fff",
                                            border: "none",
                                            borderRadius: "6px",
                                            padding: "10px 16px",
                                            cursor: "pointer",
                                            fontWeight: "600"
                                        }}
                                    >
                                        Documentos Generales
                                    </button>
                                )}
                            </div>

                            <DocumentosTable
                                documentosPaginados={documentosPaginados}
                                empleados={empleados}
                                tiposDocumento={tiposDocumento}
                                downloadFile={downloadFile}
                                setDocumentoAEliminar={setDocumentoAEliminar}
                                setMostrarModalEliminar={setMostrarModalEliminar}
                                paginaActual={paginaActual}
                                setPaginaActual={setPaginaActual}
                                totalPaginas={totalPaginas}
                                puedeEliminar={esAdministrador}
                            />

                            {/* CONTROLES DE VISUALIZACIÓN */}
                            <div
                                style={{
                                    marginTop: "20px",
                                    textAlign: "center",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    gap: "30px",
                                    flexWrap: "wrap"
                                }}
                            >
                                <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                    <label
                                        style={{
                                            fontWeight: "600"
                                        }}
                                    >
                                        Mostrar:
                                    </label>
                                    <input
                                        type="number"
                                        min="1"
                                        value={elementosPorPagina}
                                        onChange={e => {
                                            const val = e.target.value.replace(/\D/g, "");
                                            const numero = val === "" ? "" : Number(val);
                                            setElementosPorPagina(numero > 0 ? numero : 1);
                                            setPaginaActual(1);
                                        }}
                                        onFocus={e => e.target.select()}
                                        style={{
                                            width: "80px",
                                            padding: "10px",
                                            borderRadius: "6px",
                                            border: "1px solid #ccc",
                                            textAlign: "center"
                                        }}
                                    />
                                </div>

                                <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                    <input
                                        type="checkbox"
                                        id="mostrarSinArchivo"
                                        checked={mostrarSinArchivo}
                                        onChange={e => {
                                            setMostrarSinArchivo(e.target.checked);
                                            setPaginaActual(1);
                                        }}
                                        style={{
                                            width: "18px",
                                            height: "18px",
                                            cursor: "pointer"
                                        }}
                                    />
                                    <label
                                        htmlFor="mostrarSinArchivo"
                                        style={{
                                            fontWeight: "600",
                                            cursor: "pointer",
                                            color: mostrarSinArchivo ? "#1a73e8" : "#333"
                                        }}
                                    >
                                        Mostrar solo sin archivo
                                    </label>
                                </div>
                                {esAdministrador && (
                                    <div
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "10px"
                                        }}
                                    >
                                        <input
                                            type="checkbox"
                                            id="verSoloMisDocumentos"
                                            checked={verSoloMisDocumentos}
                                            onChange={(e) => {
                                                setVerSoloMisDocumentos(e.target.checked);
                                                setPaginaActual(1);
                                            }}
                                            style={{
                                                width: "18px",
                                                height: "18px",
                                                cursor: "pointer"
                                            }}
                                        />

                                        <label
                                            htmlFor="verSoloMisDocumentos"
                                            style={{
                                                fontWeight: "600",
                                                cursor: "pointer"
                                            }}
                                        >
                                            Ver solo mis documentos
                                        </label>
                                    </div>
                                )}
                            </div>
                        </div>
                    </main>
                    <Footer />
                    <ScrollToTop />
                </div>

                <ModalEliminarArchivo
                    mostrarModalEliminar={mostrarModalEliminar}
                    setMostrarModalEliminar={setMostrarModalEliminar}
                    documentoAEliminar={documentoAEliminar}
                    handleDelete={handleDelete}
                />

                <ModalDocumentosGenerales
                    mostrar={mostrarModalGeneral}
                    setMostrar={setMostrarModalGeneral}
                    form={formDocumentoGeneral}
                    onChange={onChangeDocumentoGeneral}
                    handleSubmit={handleSubmitDocumentoGeneral}
                    editingId={null}
                />

            </div>
        </Layout>
    );
};

export default DocumentosContainer;

